/* 
角色權限列表
https://www.notion.so/allpowerin/New-0f13ff5e860a46b18b90bb5a93e9df4c?showMoveTo=true&saveParent=true
*/

// roles
const _0 = "Agent";
const _1 = "Supervisor";
const _1_1 = "CrossSupervisor"; // 基於 Supervisor
const _2 = "Manager";
const _3 = "Director"; // AsusAdmin AsusMonitor 改為 Director
const _4 = "Administrator"; // ITAdmin

// router name
const Router = {
  Nav: {
    Home: [_0, _1, _1_1, _2, _3, _4],
    Chats: [_0, _1, _1_1, _2, _3, _4],
    History: [_0, _1, _1_1, _2, _3, _4],
    ChatCase: [_0, _1, _1_1, _2, _3, _4],
    Reports: [_0, _1, _1_1, _2, _3, _4],
    ACDMonitor: [_1, _1_1, _2, _3, _4],
    Dashboard: [_1, _1_1, _2, _3, _4],
    Setting: [_0, _1, _1_1, _2, _3, _4],
  },
  History: {
    Client: [_0, _1, _1_1, _2, _3, _4],
    Internal: [_0, _1, _1_1, _2, _3, _4],
    Keyword: [_2, _3, _4],
    DownloadRecords: [_2, _3, _4],
  },
  Report: {
    AgentStatus: [_0, _1, _1_1, _2, _3, _4],
    CSAT: [_1, _1_1, _2, _3, _4],
    Billing: [_1, _1_1, _2, _3, _4],
    KPI: [_1, _1_1, _2, _3, _4],
  },
  Setting: {
    Profile: [_0, _1, _1_1, _2, _3, _4],
    Chat: [_2, _3, _4],
    Bulletin: [_2, _3, _4],
    Notice: [_2, _3, _4],
    Country: [_2, _3, _4],
    ASP: [_2, _3, _4],
    Skill: [_2, _3, _4],
    User: [_2, _3, _4],
    ECLoginSwitch: [_2, _3, _4],
    ChatGPT: [_2, _3, _4],
    SNBlock: [_2, _3, _4],
  },
};

export const auth = (parent, children, role) => {
  // console.log("auth:", parent, children, role);
  return Router[parent][children].includes(role);
};

/*
用法 :
ex: auth(parent,children,role) 回傳 true or false
*/
